import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { CoursesService } from 'src/providers/courses.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  callBackForm!:FormGroup;
  submittedBtn:boolean=false;
  constructor(public formBuilder:FormBuilder, public courseService: CoursesService, public matSnackBar: MatSnackBar,
  public router: Router
  ) {
    // if(this.router.url == '/jamshedpur' || this.router.url == '/patna' || this.router.url == '/jaipur' || this.router.url == '/surat'
    //   || this.router.url == '/kolkata' || this.router.url == '/ranchi' || this.router.url == '/srinagar' || this.router.url == '/jammu' || 
    //   this.router.url == '/varanasi' || this.router.url == '/prayagraj' || this.router.url == '/chandigarh' || this.router.url == '/nagpur' || 
    //   this.router.url == '/agra' || this.router.url == '/goa' || this.router.url == '/indore' || this.router.url == '/vadodara' 
    // ){
    //   this.router.navigate(['/offline-center'+this.router.url ])
    // }
   }

  ngOnInit() {
    this.callBackForm = this.formBuilder.group({
      name:['',Validators.required],
      phone:['',Validators.compose([Validators.required,Validators.pattern('^[6-9]{1}[0-9]{9}$')])],
      course:['', Validators.required]
    })
   
    
  }

  joinwhatsapp(){
    window.open('https://api.whatsapp.com/send/?phone=918130900243', '_blank')
  }

  callback(){
    if(this.callBackForm.valid){
      this.submittedBtn = true;
      let reqObj = {
        name:this.callBackForm.value.name,
        email:'',
        phone_no:this.callBackForm.value.phone,
        course_name: this.callBackForm.value.course,
        page_location: '404'
      }
      this.courseService.callback(reqObj).subscribe(res=>{
        // this.dialogRef.close(res)
        if(res.success){
          this.matSnackBar.open('Details Submitted successfully. Our Team will contact you soon.', 'OK',{
            verticalPosition:'top',
            duration:3000,
            panelClass:'snack-success'
          })
          location.reload()
        }
      })
    }else{
      this.matSnackBar.open('Please enter valid Details', 'OK',{
        verticalPosition:'top',
        duration:3000,
        panelClass:'snack-error'
      })
    }
  
  }

}
